<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'

export default {
  name: 'EditSurchargeList',
  props: {
    rowId: { type: [String, Number], default: null },
  },
  components: { Multiselect },
  data() {
    return {
      saleTerms: [],
      variations: ['dss'],
      name: '',
      description: null,
      loadingData: false,
      extraFields: [],
    }
  },
  computed: {
    name_field() {
      return (this.variations[0] = this.name)
    },
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    fetchData() {
      axiosGetPost('get', '/cargofive/surchargers/edit/'+this.rowId).then((response) => {
        console.log(response)
        let data = response.data
        if (response.status) {
          this.name = data.name
          this.description = data.description
          this.extraFields = data.extra_fields
          this.variations = data.variations
        } else {
          this.$toastr.e('Attention. Error')
        }
        this.loadingData = false
        return response
      })
    },
    valString(element) {
      let bool = true
      if (!this[element]) {
        this.$toastr.e('Attention. Select all fields ' + element)
        bool = false
      }
      return bool
    },
    valArrays(element) {
      let bool = true
      this[element].forEach((value) => {
        if (!value) {
          this.$toastr.e('Attention. Select all fields ' + element)
          bool = false
        }
        if (!bool) return
      })
      return bool
    },
    validateFields() {
      let bool = true
      const field_select = ['name', 'description', 'variations']
      field_select.forEach((element) => {
        if (Array.isArray(this[element]) == false) {
          bool = this.valString(element)
          if (!bool) return
        } else {
          bool = this.valArrays(element)
          if (!bool) return
        }
      })
      return bool
    },
    validateFieldsArrays() {
      let bool = true
      const field_select = ['extraFields']
      console.log(this.extraFields.length)
      this.extraFields.forEach((element) => {
        console.log(element.length)
        if (element.length > 0) {
          element.forEach((value) => {
            if (!value) {
              this.$toastr.e('Attention. Select all fields extraFields')
              bool = false
            }
          })
        }
      })
      return bool
    },
    save() {
      if (!this.validateFields()) return
      if (!this.validateFieldsArrays()) return

      this.loadingData = true
      axiosGetPost('post', '/cargofive/surchargers/edit/'+this.rowId, {
        name: this.name,
        description: this.description,
        variations: this.variations,
        extra_fields: this.extraFields,
      }).then((response) => {
        console.log(response)
        if (response.success) {
          this.$toastr.s('Success. Surcharge saved')
        } else {
          this.$toastr.e('Attention. Error ' + response.message)
        }
        this.loadingData = false
        this.$emit('update_view')
        this.$emit('close_modal')
        return response
      })
    },
    newElement(variable) {
      let data = variable == 'variations' ? null : [null, null]
      this[variable].push(data)
    },
    dropElement(index, variable) {
      this[variable].splice(index, 1)
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group">
        <div class="col-md-12 row">
          <div class="col-md-5">
            <label class="mb-1 mt-0" for="name-name">Name </label>
            <b-form-input
              :id="'name-name'"
              v-model="name"
              value
              @change="name_field"
              :placeholder="'Write value name'"
            ></b-form-input>
          </div>
          <div class="col-md-6">
            <label class="mb-1 mt-0" for="name-description">Description </label>
            <b-form-input
              :id="'name-description'"
              v-model="description"
              value
              :placeholder="'Write value Description'"
            ></b-form-input>
          </div>
        </div>
        <div class="col-md-12 row">
          <div class="col-md-4">
            <label class="mb-1 mt-2" for="default"> Variations</label>
          </div>
        </div>
        <div class="col-md-12 row">
          <div
            class="col-md-4"
            v-for="(v, index) in variations"
            v-bind:key="index"
          >
            <div class="input-group mb-3">
              <b-form-input
                v-model="variations[index]"
                value
                :placeholder="'Write value '"
                class="form-control"
              ></b-form-input>
              <div
                class="input-group-prepend"
                @click="dropElement(index, 'variations')"
              >
                <span class="input-group-text">X</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 row">
            <div class="col-md-2">
              <button
                class="btn btn-sm my-4 mt-0 btn-outline-secondary form-control"
                title="New variation"
                @click="newElement('variations')"
              >
                <i class="uil uil-plus"></i>
              </button>
            </div>
          </div>
        <div class="col-md-12 row">
          <div class="col-md-12">
            <hr />
          </div>
        </div>
        <div class="col-md-12 row">
          <div class="col-md-10">
            <i>Extra fields</i>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-sm my-0 mt-0 btn-outline-secondary col-12"
              title="New variation"
              @click="newElement('extraFields')"
            >
              Add <i class="uil uil-plus"></i>
            </button>
          </div>
        </div>
        <div v-if="extraFields.length >= 1">
          <div
            class="col-md-12 row"
            v-for="(v, index) in extraFields"
            v-bind:key="index"
          >
            <div class="col-md-6">
              <label class="mb-1" for="default"
                >Name <i style="color: red">*</i>
              </label>
              <div class="input-group mb-3">
                <b-form-input
                  v-model="extraFields[index][0]"
                  value
                  :placeholder="'Write value '"
                  class="form-control"
                ></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label class="mb-1" for="default"
                >Value <i style="color: red">*</i>
              </label>
              <div class="input-group mb-3">
                <b-form-input
                  v-model="extraFields[index][1]"
                  value
                  :placeholder="'Write value '"
                  class="form-control"
                ></b-form-input>
                <div
                  class="input-group-prepend"
                  @click="dropElement(index, 'extraFields')"
                >
                  <span class="input-group-text">X</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-md-12 row">
          <b-button variant="primary" class="form-control col-4" @click="save()"
            >Save</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>